import React from "react";
import { auth, db } from "../firebaseConfig.js";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";
import "./RegisterWithGoogle.css"; // Si deseas agregar estilos personalizados

const RegisterWithGoogle = ({ text, onSuccess, onFailure }) => {
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();

    try {
      // Abre la ventana de autenticación de Google
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Registra el Service Worker y obtiene el token FCM
      const messaging = getMessaging();
      let fcmToken = null;

      try {
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        fcmToken = await getToken(messaging, {
          vapidKey: "BHs7BcXobNlY8tdmMYov5-_Q1IOFPbHtsnzpbPfRZrI4RClavJ60bj6Q5cT0aMRC2jHtYjLx_G5zmKFb3U0BUp4",
          serviceWorkerRegistration: registration,
        });

        if (!fcmToken) {
          console.warn("No se pudo obtener el token FCM. Solicita permisos al usuario.");
        }
      } catch (fcmError) {
        console.error("Error al registrar el Service Worker o al obtener el token FCM:", fcmError);
      }

      // Verifica si el usuario ya está en la colección 'users' de Firestore
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      // Si el usuario no existe en Firestore, lo crea
      if (!userDoc.exists()) {
        await setDoc(userDocRef, {
          email: user.email,
          role: "user", // Cambia el rol según sea necesario
          isServiceProvider: false, // Otro valor predeterminado
          createdAt: new Date(),
          fcmToken: fcmToken || null, // Almacena el token FCM
        });
      } else if (fcmToken) {
        // Si el usuario ya existe, actualiza el token FCM
        await setDoc(
          userDocRef,
          { fcmToken: fcmToken },
          { merge: true }
        );
      }

      if (onSuccess) onSuccess(user); // Callback en caso de éxito

    } catch (error) {
      console.error("Error al iniciar sesión con Google:", error);
      alert("Hubo un error al iniciar sesión con Google. Intenta nuevamente.");
      if (onFailure) onFailure(error); // Callback en caso de error
    }
  };

  return (
    <button onClick={handleGoogleSignIn} className="google-sign-in-button">
      {text}
    </button>
  );
};

export default RegisterWithGoogle;
